import Events from "../Utils/Events";
import Hider from "../Utils/Hider";
import ProductState from "./ProductState";

export default class ProductStateElementManager {
  private readonly extractor: (state: ProductState) => string;
  private readonly itemMap: Map<string, HTMLElement[]>;

  public constructor(dataId: string, extractor: (state: ProductState) => string) {
    this.extractor = extractor;
    const elements: NodeListOf<HTMLElement> = document.querySelectorAll(
      "[data-" + dataId + "]"
    ) as NodeListOf<HTMLElement>;

    const itemMap: Map<string, HTMLElement[]> = new Map();

    elements.forEach((e) => {
      const attribute: string = e.getAttribute("data-" + dataId)!;
      if (!itemMap.has(attribute)) {
        itemMap.set(attribute, []);
      }
      itemMap.get(attribute)!.push(e);
    });

    this.itemMap = itemMap;

    Events.on("product-state-change", (s: ProductState) => this.showHideItems(s));
  }

  private showHideItems(state: ProductState) {
    const showKey = this.extractor(state);
    this.itemMap.forEach((v, k) => v.forEach((elem) => Hider.match(elem, k == showKey)));
  }
}
